import React from 'react';
import PropTypes from 'prop-types';
import useCheckDepartment from '../../../../../hooks/shared/custom/check-department/useCheckDepartment';
import { LOGGED_IN_USER_URL } from '../../../../../services/api/auth/AuthUrl';
import { NEW_PRODUCTS, RESEARCH_AND_DEVELOPMENT, SUPER_ADMIN } from '../../../../../utils/departments/helpers';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import PurchaseOrderBody from '../../../shared/purchase-order/PurchaseOrderBody';
import WifiCallNavBar from '../../../../layouts/wificall/WifiCallNavBar';
import useCheckTwoDepartments, { useCheckThreeDepartments } from '../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';

const WifiCallPurchaseOrder = ({ history }) => {
  useCheckThreeDepartments(`${NEW_PRODUCTS}`, `${SUPER_ADMIN}`, `${RESEARCH_AND_DEVELOPMENT}`, history);
  const {
    profile: { firstName, department_id },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <WifiCallNavBar currentPage="Purchase Order" position={firstName} />
        <div className="container">
          <PurchaseOrderBody deptID={department_id} />
        </div>
      </main>
    </div>
  );
};

WifiCallPurchaseOrder.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default WifiCallPurchaseOrder;
